// extracted by mini-css-extract-plugin
export default {"overAll":"uploadimage_overAll__7pVMw","imgStyle":"uploadimage_imgStyle__nt3Ah"};